<template>
  <section class="w-full">
    <section class="relative w-full overflow-x-auto bg-white custom-scrollbar">
      <table class="w-full pb-4 mt-6 bg-white min-w-max">
        <thead class="text-gray-400 bg-white border-b border-gray-200">
          <tr>
            <th class="px-4 text-sm text-left">Payrun Type</th>
            <th class="px-4 text-sm text-left">Preview</th>
            <th class="px-4 text-sm text-left">Description</th>
            <th class="px-4 text-sm text-left">Output file</th>
            <th class="px-4 text-sm text-left">Default</th>
            <th class="px-4 text-sm text-left">Active</th>
            <th class="px-4 text-sm text-left">Action</th>
          </tr>
        </thead>
        <tbody v-if="!isLoading && payrunTypes.length">
          <tr
            v-for="(payrunType, index) in payrunTypes"
            :key="index"
            class="border-b h-max"
          >
            <td class="px-4 py-3 text-sm text-left">
              {{ payrunType.payrun_type }}
            </td>
            <td class="px-4 py-3">
              <p
                class="text-xs text-center text-white rounded-full preview-badge"
                :class="stylePayrunType(payrunType.color)"
              >
                {{ payrunType.payrun_type }}
              </p>
            </td>
            <td class="px-4 py-3 text-sm">
              {{ payrunType.description }}
            </td>
            <td class="px-4 py-3 text-sm">
              {{ payrunType.output_file.type_file }}
            </td>
            <td>
              <SwitchButton
                class="w-max"
                @update:model="
                  (value) => updateDefaultPayrun(value, payrunType)
                "
                :value="payrunType.is_default"
              />
            </td>
            <td class="px-4 py-3 text-sm">
              <SwitchButton class="w-max" :value="payrunType.is_active" />
            </td>
            <td class="relative flex p-3 text-right">
              <Button
                class="p-3 rounded-full shadow-none hover:bg-blue-100 text-primary"
                @click="$emit('on-edit', payrunType)"
              >
                <font-awesome-icon icon="fa-pen-to-square" />
              </Button>
              <Button
                class="p-3 text-red-500 rounded-full shadow-none hover:bg-red-100"
                @click="$emit('on-delete', payrunType)"
              >
                <font-awesome-icon icon="fa-trash-alt" />
              </Button>
            </td>
          </tr>
        </tbody>
      </table>
    </section>
  </section>
</template>

<script>
import SwitchButton from "@/components/SwitchButton.vue";
import Button from "@/components/Button.vue";
export default {
  name: "TablePayrunType",
  components: {
    SwitchButton,
    Button,
  },
  props: {
    payrunTypes: {
      type: Array,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    stylePayrunType(color) {
      if (color === "gray") {
        return "bg-gray-500";
      } else if (color === "green") {
        return "bg-green-500";
      } else if (color === "orange") {
        return "bg-orange-500";
      }
    },
    updateDefaultPayrun(value, process) {
      process.is_default = value;
      this.$emit("on-set-default", {
        id: process._id,
        isDefault: process.is_default,
      });
    },
  },
};
</script>

<style scoped>
.preview-badge {
  min-width: 35px;
  min-height: 25px;
  width: max-content;
  padding: 5px 20px;
  color: white;
}
</style>
